import { AppError } from './app-error';
export class BadInputError extends AppError{
    
}


// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/common/bad-input-error.ts